module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper"
  }, [_c('div', {
    staticClass: "theme-bg-img",
    class: _vm.selectedTheme
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content text-left left-content"
  }, [_c('hr'), _vm._v(" "), (_vm.newContentLoaded) ? _c('span', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.firstName) ? _c('span', [_c('h2', [(_vm.getAuthGreeting) ? _c('span', [_vm._v(_vm._s(_vm.getAuthGreeting))]) : _vm._e(), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v(", here are some videos we think you'll love.\n                            ")])]) : _c('span', [_c('h2', [(_vm.getAuthGreeting) ? _c('span', [_vm._v(_vm._s(_vm.getAuthGreeting))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n                               \t     Here are some videos we think you'll love.\n\t\t\t\t                ")])])])]), _vm._v(" "), (_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "left-panel clearfix col-xs-12 col-sm-12 col-md-8"
  }, [_c('div', {
    staticClass: "coloredpannel"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthRecommendedVideos[0].mediaid + '/' + _vm.getAuthRecommendedVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthRecommendedVideos[0].image,
      "alt": _vm.getAuthRecommendedVideos[0].title,
      "title": _vm.getAuthRecommendedVideos[0].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthRecommendedVideos[0].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('h1', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthRecommendedVideos[0].mediaid, _vm.getAuthRecommendedVideos[0].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthRecommendedVideos[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getAuthRecommendedVideos[0].description))]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  })]), _vm._v(" "), (_vm.getQuote) ? _c('div', {
    staticClass: "panel panel-default high-lighter responsive-social-icons hidemobile"
  }, [_c('h2', [_vm._v("\n                                    \" " + _vm._s(_vm.getQuote.quote) + " \" "), _c('br')]), _c('h4', [_vm._v("(" + _vm._s(_vm.getQuote.author) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "container-icons"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.quoteReference,
      "description": _vm.quoteReference,
      "title": _vm.quoteReference
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "right-panel clearfix col-xs-12 col-sm-12 col-md-4 pull-right"
  }, [(_vm.getAuthRecommendedVideos) ? _c('div', {
    staticClass: "shadowdrop"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthRecommendedVideos[1].mediaid + '/' + _vm.getAuthRecommendedVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthRecommendedVideos[1].image,
      "alt": _vm.getAuthRecommendedVideos[1].title,
      "title": _vm.getAuthRecommendedVideos[1].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthRecommendedVideos[1].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthRecommendedVideos[1].mediaid, _vm.getAuthRecommendedVideos[1].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthRecommendedVideos[1].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getAuthRecommendedVideos[1].description))]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getAuthRecommendedVideos[2]) ? _c('div', {
    staticClass: "shadowdrop"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthRecommendedVideos[2].mediaid + '/' + _vm.getAuthRecommendedVideos[2].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthRecommendedVideos[2].image,
      "alt": _vm.getAuthRecommendedVideos[2].title,
      "title": _vm.getAuthRecommendedVideos[2].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthRecommendedVideos[2].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthRecommendedVideos[2].mediaid, _vm.getAuthRecommendedVideos[2].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthRecommendedVideos[2].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getAuthRecommendedVideos[2].description))]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  })])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default interest-mood",
    class: {
      hidden: _vm.showQuestionsBox
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 col-md-5"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showQuestions
    }
  }, [_vm._v("Yes\n                                            ")])])])]), _vm._v(" "), (_vm.getAuthQuestions) ? _c('div', {
    staticClass: "col-md-12",
    class: {
      hidden: !_vm.showQuestionsBox
    }
  }, [_c('div', {
    staticClass: "questions-content"
  }, [_vm._l((_vm.getAuthQuestions), function(question) {
    return _c('div', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.setAnswer(question.questionId)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(question.question))])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "no-thanks"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.showQuestions
    }
  }, [_vm._v("no thanks")])])], 2), _vm._v(" "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left-panel clearfix col-xs-12 col-sm-12 col-md-8"
  }, [(_vm.getQuote) ? _c('div', {
    staticClass: "panel panel-default high-lighter responsive-social-icons showMobile"
  }, [_c('h2', [_vm._v("\n                                \" " + _vm._s(_vm.getQuote.quote) + " \" "), _c('br')]), _c('h4', [_vm._v("(" + _vm._s(_vm.getQuote.author) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "container-icons"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.quoteReference,
      "description": _vm.quoteReference,
      "title": _vm.quoteReference
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "charity",
    attrs: {
      "id": "auth_giving_scroll"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.getAllCharities) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content charity-content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-charity-slider"
  }, [(_vm.firstLiveEvent) ? _c('div', {
    staticClass: "row imgbalnace"
  }, [_c('div', {
    staticClass: "charity-header margin-bottom-20 "
  }, [_c('div', {
    staticClass: "title",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('h2', [_vm._v("TONE Live: " + _vm._s(_vm.getDateReference(_vm.firstLiveEvent.start_date, 'str')))])]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.currentVideo) ? _c('jwplayer', {
    attrs: {
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (!_vm.currentVideo) ? _c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.firstLiveEvent.img_url,
      "alt": "EXPERTS",
      "width": "100%",
      "alt": _vm.firstLiveEvent.title,
      "title": _vm.firstLiveEvent.title
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v(_vm._s(_vm.firstLiveEvent.title) + " ")]), _vm._v(" "), _c('p', [_vm._v("\n                                                " + _vm._s(_vm.firstLiveEvent.longDescription) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("\n                                                " + _vm._s(_vm.getDateReference(_vm.firstLiveEvent.start_date, 'str')) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.firstLiveEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.firstLiveEvent.title)
      }
    }
  }, [_vm._v("\n                                                Add to Calendar\n                                                "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.firstLiveEvent.eventId))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.firstLiveEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix>"
  }), _vm._v(" "), (_vm.showJoin(_vm.firstLiveEvent.eventId)) ? _c('button', {
    staticClass: "btn-pink",
    style: (_vm.styleObject),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent(_vm.firstTalkEvent)
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa 2x fa-arrow-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Go to Event ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.firstTalkEvent) ? _c('div', {
    staticClass: "row imgbalnace"
  }, [_c('div', {
    staticClass: "charity-header margin-bottom-20"
  }, [_c('div', {
    staticClass: "title",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('h2', [_vm._v("TONE Talk: " + _vm._s(_vm.getDateReference(_vm.firstTalkEvent.start_date, 'str')))])]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.firstTalkEvent.img_url,
      "alt": "EXPERTS",
      "width": "100%",
      "alt": _vm.firstTalkEvent.title,
      "title": _vm.firstTalkEvent.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v(_vm._s(_vm.firstTalkEvent.title) + " ")]), _vm._v(" "), _c('p', [_vm._v("\n                                                " + _vm._s(_vm.firstTalkEvent.longDescription) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("\n                                                " + _vm._s(_vm.getDateReference(_vm.firstTalkEvent.start_date, 'str')) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.firstTalkEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.firstTalkEvent.title)
      }
    }
  }, [_vm._v("\n                                                Add to Calendar\n                                                "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.firstTalkEvent.eventId))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.firstTalkEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix>"
  }), _vm._v(" "), (_vm.showJoin(_vm.firstTalkEvent.eventId)) ? _c('button', {
    staticClass: "btn-pink",
    style: (_vm.styleObject),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent(_vm.firstTalkEvent)
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa 2x fa-arrow-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Go to Event ")]) : _vm._e(), _vm._v(" "), _c('br')])])]) : _vm._e()])])])]) : _vm._e()])]), _vm._v(" "), (_vm.getAuthRecentlyWatchedVideos) ? _c('div', {
    staticClass: "recently-watched"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.getAuthRecentlyWatchedVideos), function(reccentVideo) {
    return _c('div', [_c('div', {
      staticClass: "slide-player"
    }, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/watch/' + reccentVideo.mediaid + '/' + reccentVideo.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "jw-img-1",
      attrs: {
        "src": reccentVideo.image,
        "alt": reccentVideo.title,
        "title": reccentVideo.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title-1 recent-style cursor"
    }, [_vm._v(_vm._s(_vm.formattedDuration(reccentVideo.duration)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor postion-title"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o"
    }), _vm._v(" " + _vm._s(reccentVideo.title) + "\n                                            ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
      staticClass: "right-heart-icon"
    }, [_c('a', {
      staticStyle: {
        "outline": "none"
      },
      attrs: {
        "href": "javascript:",
        "title": "Liked this video?"
      },
      on: {
        "click": function($event) {
          return _vm.setVideoStatus(reccentVideo)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-2x fa-heart-o",
      class: {
        'activeIcons': _vm.getVideoStatus(reccentVideo)
      },
      style: ({
        color: _vm.getCorpHeaderColor
      }),
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-danger recently-watched-btn btn-transparent btn-lg",
    style: (_vm.styleObject),
    on: {
      "click": function($event) {
        return _vm.setRecentlyWatchedVideos()
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_vm._v("View All Your Videos")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "expert-section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row margin-top-40"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('tabs', {
    staticClass: "expert-tabs",
    attrs: {
      "nav-style": "tabs",
      "justified": ""
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [(_vm.firstLiveEvent) ? _c('tab', {
    attrs: {
      "header": "TONE Live"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.firstLiveEvent.img_url,
      "alt": "EXPERTS",
      "width": "100%",
      "alt": _vm.firstLiveEvent.title,
      "title": _vm.firstLiveEvent.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v(_vm._s(_vm.firstLiveEvent.title))]), _vm._v(" "), _c('p', [_vm._v("\n                                                " + _vm._s(_vm.firstLiveEvent.longDescription) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("\n                                                LIVE " + _vm._s(_vm.getDateReference(_vm.firstLiveEvent.start_date, 'str')) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.firstLiveEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.firstLiveEvent.title)
      }
    }
  }, [_vm._v("\n                                                Add to Calendar\n                                                "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.firstLiveEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.firstLiveEvent.eventId))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.firstLiveEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix>"
  }), _vm._v(" "), (_vm.showJoin(_vm.firstLiveEvent.eventId)) ? _c('button', {
    staticClass: "btn-pink",
    style: (_vm.styleObject),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent(_vm.firstLiveEvent)
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa 2x fa-arrow-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Go to Event ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "TONE Talks"
    }
  }, [(_vm.firstTalkEvent) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.firstTalkEvent.img_url,
      "alt": "EXPERTS",
      "width": "100%",
      "alt": _vm.firstTalkEvent.title,
      "title": _vm.firstTalkEvent.title
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('h2', [_vm._v(_vm._s(_vm.firstTalkEvent.title) + " ")]), _vm._v(" "), _c('p', [_vm._v("\n                                                " + _vm._s(_vm.firstTalkEvent.longDescription) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("\n                                                " + _vm._s(_vm.getDateReference(_vm.firstTalkEvent.start_date, 'str')) + "\n                                            ")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.showJoin(_vm.firstTalkEvent.eventId)) ? _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.firstTalkEvent.title)
      }
    }
  }, [_vm._v("\n                                                Add to Calendar\n                                                "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.firstTalkEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.firstTalkEvent.eventId))])]) : _vm._e(), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCorporateImageShareModal(_vm.firstTalkEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix>"
  }), _vm._v(" "), (_vm.showJoin(_vm.firstTalkEvent.eventId)) ? _c('button', {
    staticClass: "btn-pink",
    style: (_vm.styleObject),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent(_vm.firstTalkEvent)
      },
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa 2x fa-arrow-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Go to Event ")]) : _vm._e()])])]) : _vm._e()])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "random"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "margin-top-40"
  }, [_c('div', {
    staticClass: "blog-section clearfix"
  }, [_c('div', {
    staticClass: "row random-section-head"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('svg', {
    attrs: {
      "width": "47px",
      "height": "48px",
      "viewBox": "0 0 47 48",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Work")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-666.000000, -819.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-7",
      "transform": "translate(88.000000, 800.000000)"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Work",
      "transform": "translate(666.000000, 819.000000)",
      "fill": _vm.getCorpHeaderColor
    }
  }, [_c('path', {
    attrs: {
      "d": "M45.6944444,-1.62630326e-19 C34.1361,-1.62630326e-19 23.4467333,5.0007033 15.9565,13.1868132 L1.30555556,13.1868132 C0.777223333,13.1868132 0.301896667,13.5082444 0.0999533333,14.0007033 C-0.102000444,14.4931464 0.0101937778,15.0597626 0.383504333,15.4368527 L8.84924878,23.9877099 C7.97410878,25.934822 7.23772322,27.964378 6.66651656,30.0742154 C6.54208144,30.5316343 6.67059511,31.0199736 7.00310444,31.3537582 L15.9566044,40.3988571 C16.2054747,40.6502295 16.5379944,40.78416 16.8806767,40.78416 C16.9949128,40.78416 17.1111908,40.7697389 17.2254269,40.7367719 C19.3143158,40.1598224 21.3257069,39.4160334 23.2513491,38.5320949 L31.7170936,47.082951 C31.9659638,47.3384482 32.3005202,47.4723735 32.6391291,47.4723735 C32.8064021,47.4723735 32.9777589,47.4394064 33.1389114,47.3714099 C33.6264529,47.1674258 33.9447003,46.6873308 33.9447003,46.1536869 L33.9447003,31.3554462 C42.0495892,23.7893802 47.0002559,12.9930725 47.0002559,1.31852308 C47.0002559,0.589134066 46.4168292,-0.000158241758 45.6947003,-0.000158241758 L45.6944444,-1.62630326e-19 Z M17.2599667,37.9864615 L9.39216667,30.0395604 C12.5765211,19.1398681 20.3483889,10.4882637 30.2074222,6.00474725 L41.0576333,16.9619341 C36.6167078,26.9200879 28.0532556,34.7725714 17.2599667,37.9864615 Z M44.3664333,2.66004396 C44.2256788,6.70881758 43.4484711,10.6275165 42.12657,14.3098022 L32.8325811,4.92448352 C36.4759167,3.58934505 40.3578033,2.80225055 44.3663811,2.66004396 L44.3664333,2.66004396 Z M4.45716667,15.8241758 L13.7407111,15.8241758 C12.3719144,17.5982242 11.1438567,19.4958593 10.0749722,21.4987253 L4.45716667,15.8241758 Z M31.3333333,42.9705495 L25.7152667,37.296 C27.6980922,36.2142593 29.5748022,34.9739077 31.3333333,33.5934066 L31.3333333,42.9705495 Z",
      "id": "Fill-1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.30555556,47.4725275 C1.64010156,47.4725275 1.97462667,47.3447789 2.22962778,47.0872246 L7.45185,41.8124993 C7.96183133,41.2973908 7.96183133,40.4629081 7.45185,39.9477785 C6.94186867,39.4326699 6.11569222,39.4326699 5.60569,39.9477785 L0.383467778,45.2225037 C-0.126513556,45.7376123 -0.126513556,46.5720949 0.383467778,47.0872246 C0.636421778,47.3447789 0.970967778,47.4725275 1.30550333,47.4725275 L1.30555556,47.4725275 Z",
      "id": "Fill-2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.909,47.0874709 C7.16399067,47.3450252 7.49853667,47.4727738 7.83307222,47.4727738 C8.16760778,47.4727738 8.50214333,47.3450252 8.75714444,47.0874709 L12.6738111,43.1314286 C13.1837924,42.61632 13.1837924,41.7818374 12.6738111,41.2667077 C12.1638298,40.7515991 11.3376533,40.7515991 10.8276511,41.2667077 L6.91098444,45.2227501 C6.40100311,45.7358015 6.40100311,46.5723407 6.90894256,47.0874709 L6.909,47.0874709 Z",
      "id": "Fill-3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.30555556,40.8791209 C1.64010156,40.8791209 1.97462667,40.7513723 2.22962778,40.493818 L6.14629444,36.5377741 C6.65627578,36.0226655 6.65627578,35.1881829 6.14629444,34.6730532 C5.63631311,34.1579446 4.81013667,34.1579446 4.30013444,34.6730532 L0.383467778,38.6290971 C-0.126513556,39.1442057 -0.126513556,39.9786884 0.383467778,40.493818 C0.636421778,40.7513723 0.970967778,40.8791209 1.30550333,40.8791209 L1.30555556,40.8791209 Z",
      "id": "Fill-4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M26.1111111,14.5054945 C22.51065,14.5054945 19.5833333,17.4622418 19.5833333,21.0989011 C19.5833333,24.7355604 22.51065,27.6923077 26.1111111,27.6923077 C29.7115722,27.6923077 32.6388889,24.7355604 32.6388889,21.0989011 C32.6388889,17.4622418 29.7115722,14.5054945 26.1111111,14.5054945 Z M26.1111111,25.0549451 C23.9508344,25.0549451 22.1944444,23.2808967 22.1944444,21.0989011 C22.1944444,18.9169055 23.9508344,17.1428571 26.1111111,17.1428571 C28.2713878,17.1428571 30.0277778,18.9169055 30.0277778,21.0989011 C30.0277778,23.2808967 28.2713878,25.0549451 26.1111111,25.0549451 Z",
      "id": "Fill-5"
    }
  })])])])]), _vm._v(" "), _c('br'), _vm._v("WORK"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthWorkVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthWorkVideos[0].mediaid + '/' + _vm.getAuthWorkVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthWorkVideos[0].image,
      "alt": _vm.getAuthWorkVideos[0].title,
      "title": _vm.getAuthWorkVideos[0].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthWorkVideos[0].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthWorkVideos[0].mediaid, _vm.getAuthWorkVideos[0].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthWorkVideos[0].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "workVideo1",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('workVideo1')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthWorkVideos[0])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthWorkVideos[0], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthWorkVideos[0]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthWorkVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthWorkVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('workVideo1')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthWorkVideos[0])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthWorkVideos[0])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthWorkVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthWorkVideos[1].mediaid + '/' + _vm.getAuthWorkVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthWorkVideos[1].image,
      "alt": _vm.getAuthWorkVideos[1].title,
      "title": _vm.getAuthWorkVideos[1].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthWorkVideos[1].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthWorkVideos[1].mediaid, _vm.getAuthWorkVideos[1].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthWorkVideos[1].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "workVideo2",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('workVideo2')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthWorkVideos[1])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthWorkVideos[1], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthWorkVideos[1]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthWorkVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthWorkVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('workVideo2')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthWorkVideos[1])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthWorkVideos[1])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40 watch-all"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/work'
      }
    }
  }, [_vm._v("\n                                                See  All  Work  "), _c('span', {
    staticClass: "fa fa-angle-double-right fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('svg', {
    attrs: {
      "width": "34px",
      "height": "47px",
      "viewBox": "0 0 34 47",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Page 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-125.000000, -1270.000000)",
      "fill": _vm.getCorpHeaderColor
    }
  }, [_c('path', {
    attrs: {
      "d": "M131.268161,1315.78641 C130.977535,1315.78641 130.686929,1315.70766 130.426289,1315.54453 C129.798161,1315.15078 129.528161,1314.37453 129.775649,1313.67517 L136.398209,1294.97773 L127.583969,1294.97586 C127.028993,1294.97586 126.513329,1294.68524 126.226481,1294.20709 C125.939604,1293.73084 125.924604,1293.1402 126.18523,1292.64896 L137.24011,1271.84 C137.515735,1271.32251 138.051982,1271 138.638878,1271 L153.378238,1271 C153.97075,1271 154.512622,1271.33 154.786366,1271.85498 C155.058242,1272.38187 155.015114,1273.01374 154.671991,1273.49749 L145.384951,1286.60725 L157.062391,1286.60725 C157.701751,1286.60725 158.277367,1286.99162 158.524903,1287.58035 C158.770529,1288.17099 158.637406,1288.85158 158.187406,1289.30538 L132.393166,1315.31898 C132.08754,1315.62648 131.678782,1315.78585 131.268142,1315.78585 L131.268161,1315.78641 Z M130.218161,1291.80897 L138.638801,1291.80897 C139.152545,1291.80897 139.634417,1292.05834 139.932545,1292.47833 C140.228796,1292.89833 140.303796,1293.43646 140.131294,1293.9202 L135.121054,1308.0706 L153.261694,1289.77444 L142.322974,1289.77444 C141.730462,1289.77444 141.18859,1289.44444 140.916718,1288.91755 C140.644841,1288.39252 140.687969,1287.75878 141.031092,1287.27503 L150.316212,1274.16527 L139.591092,1274.16527 L130.218161,1291.80897 Z",
      "id": "Page-1",
      "stroke": "#FFFFFF",
      "stroke-width": "0.5"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-7-Copy",
      "transform": "translate(126.000000, 1315.000000)",
      "font-size": "30",
      "font-family": "Quicksand-Regular, Quicksand",
      "line-spacing": "60",
      "font-weight": "normal"
    }
  }, [_c('text', {
    attrs: {
      "id": "Inspiration"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "0",
      "y": "28"
    }
  }, [_vm._v("Inspiration")])])])])])]), _vm._v(" "), _c('br'), _vm._v("LIFE"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthLifeVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthLifeVideos[0].mediaid + '/' + _vm.getAuthLifeVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthLifeVideos[0].image,
      "alt": _vm.getAuthLifeVideos[0].title,
      "title": _vm.getAuthLifeVideos[0].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthLifeVideos[0].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthLifeVideos[0].mediaid, _vm.getAuthLifeVideos[0].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthLifeVideos[0].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "lifeVideo1",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('lifeVideo1')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthLifeVideos[0])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthLifeVideos[0], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthLifeVideos[0]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthLifeVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthLifeVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('lifeVideo1')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthLifeVideos[0])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthLifeVideos[0])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthLifeVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthLifeVideos[1].mediaid + '/' + _vm.getAuthLifeVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthLifeVideos[1].image,
      "alt": _vm.getAuthLifeVideos[1].title,
      "title": _vm.getAuthLifeVideos[1].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthLifeVideos[1].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthLifeVideos[1].mediaid, _vm.getAuthLifeVideos[1].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthLifeVideos[1].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "lifeVideo2",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('lifeVideo2')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthLifeVideos[1])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthLifeVideos[1], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthLifeVideos[1]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthLifeVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthLifeVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('lifeVideo2')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthLifeVideos[1])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthLifeVideos[1])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40 watch-all"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/life'
      }
    }
  }, [_vm._v("\n                                                See  All  Life  "), _c('span', {
    staticClass: "fa fa-angle-double-right fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('svg', {
    attrs: {
      "width": "59px",
      "height": "49px",
      "viewBox": "0 0 59 49",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Page 1")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "01_Tone_Home_Unauthenticated",
      "transform": "translate(-665.000000, -1737.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-7-Copy-2",
      "transform": "translate(88.000000, 1726.000000)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M720.393793,1779.55672 L720.248873,1779.68175 C715.432452,1783.90429 709.738162,1785.73139 704.609017,1784.72833 C699.982965,1783.81053 696.672699,1780.75588 693.478531,1777.80351 C690.014703,1774.60396 686.749756,1771.58336 681.933407,1771.06622 C677.116986,1770.54906 671.859885,1772.76828 667.705503,1777.21247 C669.319536,1779.4601 677.002852,1788.69794 689.528558,1781.06846 C689.863862,1780.92922 690.250312,1781.05993 690.432178,1781.3725 C690.616881,1781.68791 690.540158,1782.08858 690.256,1782.31308 C686.488104,1784.60333 683.098184,1785.47 680.137377,1785.47 C671.226296,1785.47 666.177169,1777.64134 666.111699,1777.53368 C665.938366,1777.25805 665.969624,1776.90286 666.185578,1776.66134 C670.717863,1771.5693 676.494789,1769.01454 682.035663,1769.61148 C687.332264,1770.17979 690.932195,1773.51009 694.402061,1776.72667 C697.587427,1779.63641 700.599445,1782.45806 704.824752,1783.27358 C709.510453,1784.20557 714.752788,1782.48934 719.214148,1778.55944 L719.387481,1778.41452 L719.390325,1778.41452 C719.95579,1777.95987 720.4985,1777.47395 721.012869,1776.95965 C718.830564,1771.81079 712.885963,1770.61729 711.700971,1770.41273 C709.538525,1771.73688 707.199966,1772.74845 704.753384,1773.41624 C704.688023,1773.42477 704.622671,1773.42477 704.557318,1773.41624 C704.364097,1773.44182 704.168024,1773.39067 704.014586,1773.27132 C703.858304,1773.15481 703.756004,1772.97864 703.730428,1772.78542 C703.676438,1772.38476 703.957751,1772.01535 704.361252,1771.96138 C711.774544,1769.85298 716.363933,1765.82932 718.023212,1760.01544 L718.020368,1760.01544 C718.710864,1757.52906 718.84157,1754.92055 718.406818,1752.37737 C708.347844,1751.34303 704.105442,1757.36146 703.479848,1758.34175 C702.920065,1762.26874 701.13838,1766.18423 698.154804,1770.03746 L698.154804,1770.0403 C697.901904,1770.33014 697.467153,1770.37276 697.163092,1770.13691 C696.859031,1769.90106 696.790849,1769.47199 697.00681,1769.15371 C699.916551,1765.55349 701.610092,1761.82844 702.113041,1758.08869 C702.323314,1756.53155 702.323314,1754.95447 702.113041,1753.39732 C701.152608,1746.12297 695.821891,1741.03092 694.213823,1739.64152 C685.803217,1747.42435 687.308862,1755.83277 689.090497,1760.34505 C689.749735,1761.44472 690.332228,1762.58984 690.838014,1763.76909 C691.036924,1764.1186 690.917581,1764.56476 690.56807,1764.76648 C690.218559,1764.96822 689.772402,1764.84604 689.570684,1764.49653 C688.925652,1763.47361 688.377254,1762.38813 687.933955,1761.26003 C685.314024,1756.82151 681.773452,1754.05958 677.371596,1753.03346 C675.11822,1752.51062 672.779661,1752.47652 670.5121,1752.93969 C668.409376,1759.30475 672.810941,1765.04494 672.853569,1765.10168 C673.10078,1765.41993 673.043953,1765.87741 672.728537,1766.1246 C672.410284,1766.36897 671.9528,1766.31214 671.705618,1765.99673 C671.495345,1765.72678 666.613571,1759.34753 669.267546,1752.0678 L669.267546,1752.06496 C669.34995,1751.84899 669.526127,1751.68703 669.74777,1751.62167 C672.799578,1750.91981 675.984944,1751.05621 678.968738,1752.01665 C681.949549,1752.97708 684.614872,1754.72751 686.683188,1757.07741 C685.680128,1751.88309 686.291057,1744.71102 693.718868,1738.1641 L693.716024,1738.1641 C693.985968,1737.9453 694.372418,1737.9453 694.64234,1738.1641 C694.969118,1738.36016 702.337149,1744.07167 703.573062,1753.22128 C703.689568,1754.11355 703.743558,1755.00859 703.735032,1755.90653 C705.968477,1753.55655 710.776387,1750.08705 719.16466,1751.11288 L719.161823,1751.11288 C719.457344,1751.14982 719.698874,1751.36294 719.772752,1751.64993 C719.772752,1751.78064 722.384099,1762.39415 713.416205,1769.32733 C715.976414,1769.98089 720.690557,1771.8364 722.565885,1776.8061 C722.79889,1777.38009 722.429491,1777.84611 720.392091,1779.55667 L720.393793,1779.55672 Z",
      "id": "Page-1",
      "stroke": _vm.getCorpHeaderColor,
      "fill": _vm.getCorpHeaderColor
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v("MIND BODY"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthMindbodyVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthMindbodyVideos[0].mediaid + '/' + _vm.getAuthMindbodyVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthMindbodyVideos[0].image,
      "alt": _vm.getAuthMindbodyVideos[0].title,
      "title": _vm.getAuthMindbodyVideos[0].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthMindbodyVideos[0].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthMindbodyVideos[0].mediaid, _vm.getAuthMindbodyVideos[0].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthMindbodyVideos[0].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "mindbodyVideo1",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('mindbodyVideo1')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(13)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthMindbodyVideos[0])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthMindbodyVideos[0], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthMindbodyVideos[0]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthMindbodyVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthMindbodyVideos[0].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('mindbodyVideo1')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthMindbodyVideos[0])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthMindbodyVideos[0])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.getAuthMindbodyVideos) ? _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('a', {
    staticClass: "nounderline",
    attrs: {
      "href": '/watch/' + _vm.getAuthMindbodyVideos[1].mediaid + '/' + _vm.getAuthMindbodyVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "jw-img-1",
    attrs: {
      "src": _vm.getAuthMindbodyVideos[1].image,
      "alt": _vm.getAuthMindbodyVideos[1].title,
      "title": _vm.getAuthMindbodyVideos[1].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title-1 align-to-bottom cursor"
  }, [_vm._v(_vm._s(_vm.formattedDuration(_vm.getAuthMindbodyVideos[1].duration)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40"
  }, [_c('h4', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        return _vm.setVideoPlayerObject(_vm.getAuthMindbodyVideos[1].mediaid, _vm.getAuthMindbodyVideos[1].title)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" " + _vm._s(_vm.getAuthMindbodyVideos[1].title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "plusicon btn-group"
  }, [_c('button', {
    staticClass: "dropdown-toggle ellipsis pull-right",
    attrs: {
      "title": "Add to Playlist",
      "id": "mindbodyVideo2",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showPlaylistMenu('mindbodyVideo2')
      }
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "37px",
      "height": "24px",
      "viewBox": "0 0 37 24",
      "enable-background": "new 0 0 37 24",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "8.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "25",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "y": "17.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "18.2",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "23",
      "y": "15.2",
      "fill": _vm.getCorpHeaderColor,
      "width": "14",
      "height": "4"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "27.958",
      "y": "10.242",
      "fill": _vm.getCorpHeaderColor,
      "width": "4",
      "height": "13.917"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "hide"
  }, [(_vm.getUserPlaylists) ? _c('li', [_vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getUserPlaylists), function(playlist) {
    return (_vm.getUserPlaylists) ? _c('li', [_c('label', {
      staticClass: "notificationwithcheckboxes"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.verifyVideoExists(playlist, _vm.getAuthMindbodyVideos[1])
      },
      on: {
        "click": function($event) {
          _vm.setPlaylistVideoStatus(_vm.getAuthMindbodyVideos[1], playlist, _vm.verifyVideoExists(playlist, _vm.getAuthMindbodyVideos[1]))
        }
      }
    }), _vm._v(" " + _vm._s(playlist.title) + "\n                                                            "), (_vm.getAuthMindbodyVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoAdded) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "added"
    }, [_vm._v("Added")])]) : _vm._e(), _vm._v(" "), (_vm.getAuthMindbodyVideos[1].mediaid === _vm.selectedVideo && playlist.playlistId === _vm.selectedPlaylist && _vm.videoRemoved) ? _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('span', {
      staticClass: "removed"
    }, [_vm._v("Removed")])]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.getUserPlaylists) ? _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlaylistName),
      expression: "newPlaylistName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newPlaylistName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlaylistName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "title": "Insert New Playlist"
    },
    on: {
      "click": _vm.addNewPlayList
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "backdropformenu",
    on: {
      "click": function($event) {
        return _vm.hidePlaylistMenu('mindbodyVideo2')
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right-heart-icon"
  }, [_c('a', {
    attrs: {
      "href": "javascript:",
      "title": "Liked this video?"
    },
    on: {
      "click": function($event) {
        return _vm.setVideoStatus(_vm.getAuthMindbodyVideos[1])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-heart-o",
    class: {
      'activeIcons': _vm.getVideoStatus(_vm.getAuthMindbodyVideos[1])
    },
    style: ({
      color: _vm.getCorpHeaderColor
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('div', {
    staticClass: "col-md-12 margin-top-20 margin-bottom-40 watch-all"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/mindbody'
      }
    }
  }, [_vm._v("\n                                                See  All  Mind Body  "), _c('span', {
    staticClass: "fa fa-angle-double-right fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])])])])])]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    attrs: {
      "effect": "zoom",
      "value": _vm.showModal,
      "width": "400"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.currentVideoDesc) ? _c('p', [_vm._v("\n                    " + _vm._s(_vm.currentVideoDesc) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('p', [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "quote": _vm.quoteReference,
      "description": _vm.quoteReference,
      "title": _vm.quoteReference
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('strong', [_vm._v("Surprise!!")]), _vm._v(" We found new content for you")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-7 col-md-7 extra-small"
  }, [_c('h4', [_vm._v("\n                                                In the mood for "), _c('br'), _vm._v("\n                                                something else\n                                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("RECENTLY WATCHED")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "applicationdownload"
  }, [_c('img', {
    staticClass: "showmobile",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-new.png",
      "alt": "DOWNLOAD TONE APP",
      "title": "Download TONE App"
    }
  }), _vm._v(" "), _c('h2', [_c('b', [_vm._v("Get TONE on your Phone with the TONE app")])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://apps.apple.com/us/app/tone-networks-advice-on-demand/id1444962883?ls=1"
    }
  }, [_c('img', {
    staticClass: "appbtn",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-apple.png",
      "alt": "DOWNLOAD APPLE APP",
      "title": "Download App on IOS"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://play.google.com/store/apps/details?id=com.tonenetworks.toneapp"
    }
  }, [_c('img', {
    staticClass: "appbtn",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-android.png",
      "alt": "DOWNLOAD ANDROID APP",
      "title": "Download App on Android"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v("EVENTS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('b', [_vm._v(" Add to ...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', {
    staticStyle: {
      "color": "#f0617d"
    }
  }, [_vm._v("Create new playlist")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-331b4fd3", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-331b4fd3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Hello.vue